import Modal from 'react-modal';
import { useState } from 'react';
import { deleteQrConfiguration } from 'api/qr';
import { QrConfiguration } from './types';
import swal from 'sweetalert';

Modal.setAppElement('#root');

interface Props {
    isOpen: boolean;
    config: QrConfiguration | null;
    onClose: () => void;
    onDeleted: () => void;
}

const QrDeleteDialog = ({ isOpen, config, onClose, onDeleted }: Props) => {
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        if (!config) return;
        setLoading(true);
        try {
            await deleteQrConfiguration(config.id);
            onDeleted();
            onClose();
        } catch {
            swal('Afinidata', 'Error al eliminar la configuración', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onRequestClose={onClose} contentLabel="Eliminar QR"
            style={{
                overlay: { backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1050 },
                content: { position: 'relative', inset: 'auto', maxWidth: 420, width: '100%', borderRadius: 8, padding: 0 }
            }}>
            <div className="card mb-0">
                <div className="card-header">
                    <h5 className="mb-0">Eliminar configuración QR</h5>
                </div>
                <div className="card-body">
                    <p>¿Eliminar <strong>{config?.name}</strong> (<code>{config?.slug}</code>)?</p>
                    <p className="text-danger mb-0">Esta acción es permanente y no puede deshacerse.</p>
                </div>
                <div className="card-footer d-flex justify-content-end">
                    <button className="btn btn-secondary mr-2" onClick={onClose} disabled={loading}>Cancelar</button>
                    <button className="btn btn-danger" onClick={handleConfirm} disabled={loading}>
                        {loading ? 'Eliminando...' : 'Eliminar'}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default QrDeleteDialog;
